import React, { createContext, useContext, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import { AmendmentCreateEditReducer, AmendmentCreateEditState, ACTION_TYPES } from './amendment-create-edit-reducer';

const AmendmentCreateEditContext = createContext<AmendmentCreateEditState | undefined>(undefined);
const AmendmentCreateEditDispatchContext = createContext({} as any);

const AmendmentCreateEditProvider = ({ children }: { children: React.ReactNode }) => {
    const { contractId, sequentialId } = useParams();

    const initialState: AmendmentCreateEditState = {
        contractId: contractId,
        sequentialId: sequentialId,
        amendmentRequest: {},
        showValidationErrors: false,
    };

    const [state, dispatch] = useReducer(AmendmentCreateEditReducer, initialState);

    return (
        <AmendmentCreateEditContext.Provider value={state}>
            <AmendmentCreateEditDispatchContext.Provider value={dispatch}>
                {children}
            </AmendmentCreateEditDispatchContext.Provider>
        </AmendmentCreateEditContext.Provider>
    );
}

const useAmendmentCreateEditState = () => {
    const context = useContext(AmendmentCreateEditContext);
    if (context === undefined) {
        throw new Error('useAmendmentCreateEditState must be used within a AmendmentCreateEditProvider');
    }
    return context;
}

const useAmendmentCreateEditDispatch = () => {
    const context = useContext(AmendmentCreateEditDispatchContext);
    if (context === undefined) {
        throw new Error('useAmendmentCreateEditDispatch must be used within a AmendmentCreateEditProvider');
    }
    return context;
}

export { AmendmentCreateEditProvider, useAmendmentCreateEditDispatch, useAmendmentCreateEditState, ACTION_TYPES };
